
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/service-suppliers",
      function () {
        return require("private-next-pages/service-suppliers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/service-suppliers"])
      });
    }
  